import React from "react";
import { IonHeader, IonToolbar, IonRow, IonCol, IonLabel } from "@ionic/react";
import CustomCalendar from "../CustomCalendar";
import UtcTime from "../../common/UtcTime";
import { FilterChips } from "./FilterChips";
import { ConfigButton } from "./ConfigButton";

/**
 * Header component for FlyDay
 */
export const FlyDayHeader = ({
  flyDay,
  channelConnected,
  getFlyDay,
  markTowId,
  active,
  filterPilotSelector,
  filterGliderSelector,
  filterTowingPlaneSelector,
  filterTowingPilotSelector,
  onFilterPilotRemove,
  onFilterGliderRemove,
  onFilterTowingPlaneRemove,
  onFilterTowingPilotRemove,
  onConfigClick,
  setNavigationType
}) => {
  return (
    <IonHeader>
      <IonToolbar>
        <IonRow>
          <IonCol size="4">
            <IonLabel>
              <h2 className="date">
                {channelConnected ? (
                  <div className="btn">
                    <strong>{flyDay && <CustomCalendar date={flyDay.day} />}</strong>
                  </div>
                ) : (
                  <span><strong>Odpojeno!</strong></span>
                )}
              </h2>
              <h2>
                <UtcTime time={flyDay?.time} update={getFlyDay} />
                {/*markTowId*/}
              </h2>
            </IonLabel>
          </IonCol>
          {filterPilotSelector || filterGliderSelector || filterTowingPlaneSelector || filterTowingPilotSelector ? (
            <FilterChips
              flyDay={flyDay}
              filterPilotSelector={filterPilotSelector}
              filterGliderSelector={filterGliderSelector}
              filterTowingPlaneSelector={filterTowingPlaneSelector}
              filterTowingPilotSelector={filterTowingPilotSelector}
              onFilterPilotRemove={onFilterPilotRemove}
              onFilterGliderRemove={onFilterGliderRemove}
              onFilterTowingPlaneRemove={onFilterTowingPlaneRemove}
              onFilterTowingPilotRemove={onFilterTowingPilotRemove}
            />
          ) : (
            <ConfigButton
              active={active}
              onConfigClick={onConfigClick}
              setNavigationType={setNavigationType}
            />
          )}
        </IonRow>
      </IonToolbar>
    </IonHeader>
  );
};

